<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'aulas',
                  params: { gestaoDeAulaId: $route.params.gestaoDeAulaId },
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Aula
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="primary" class="mb-5 d-flex" outlined dark>
          <v-card-text>
            <h4>Turma: {{ gestaoDeAula.turma.descricao }}</h4>
            <template v-if="!gestaoDeAula.is_polivalencia">
              <h4>Disciplina: {{ gestaoDeAula.disciplina?.descricao }}</h4>
            </template>
            <template v-else>
              <h4>Disciplinas:</h4>
              <div class="container">
                <div class="row">
                  <div v-for="(item, index) in gestaoDeAula.disciplinas" :key="index">
                    <v-chip class="ml-2" x-small>{{ item.descricao }} </v-chip>
                  </div>
                </div>
              </div>
            </template>
            <h4>
              Professor:
              {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[Carregando...]" }}
            </h4>
            <h4>
              Turno:
              {{
                gestaoDeAula.turma.turno ? gestaoDeAula.turma.turno.descricao : "[NÃO INFORMADO]"
              }}
            </h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <ValidationObserver v-if="etapas" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row>
          <v-col cols="12" md="8" v-if="etapas?.length">
            <ValidationProvider name="Etapa" rules="required" v-slot="{ errors }">
              <div class="d-flex align-center">
                <div class="flex-grow-1">
                  <e-label
                    >Etapas
                    <v-chip
                      small
                      v-if="
                        etapaSelecionada?.periodo_extensao &&
                        etapaSelecionada?.periodo_extensao >= dataAtualFormatada
                      "
                      class="text-none"
                      :color="getChipColor(etapaSelecionada?.periodo_extensao)"
                    >
                      Estendido até: {{ dateFormatConvert(etapaSelecionada?.periodo_extensao) }}
                    </v-chip>
                    <v-chip
                      small
                      class="text-none"
                      style="color: #fff"
                      color="green darken-3"
                      v-if="
                        etapaSelecionada?.id === pedidoAprovado?.etapa_id &&
                        pedidoAprovado &&
                        (editing ? true : etapaSelecionada.periodo_extensao === null)
                      "
                      >Solicitação de Lançamento de Aulas Aprovada -
                      <strong v-if="pedidoAprovado.data_expiracao">
                        Válido até {{ validarData(pedidoAprovado.data_expiracao) }}</strong
                      >
                      <strong v-else>Prazo Indefinido</strong>
                    </v-chip>
                    <v-chip
                      small
                      class="text-none"
                      style="color: #fff"
                      color="red darken-3"
                      v-if="pedidoRecusado && etapaPendente == false"
                      >Seu último pedido para lançamento de aula foi recusado!
                    </v-chip>
                  </e-label>
                  <e-autocomplete
                    v-if="editing"
                    :items="etapas"
                    :return-object="false"
                    :error-messages="errors"
                    :item-text="
                      (item) =>
                        `${item.descricao} - Início: ${dateFormatConvert(
                          item.periodo_inicial
                        )} Fim: ${dateFormatConvert(item.periodo_final)}`
                    "
                    :item-value="(item) => item.id"
                    v-model="etapaSelecionada"
                    @change="() => verificarEtapaSelecionada()"
                    label="Selecione uma Etapa"
                    dense
                    solo
                  />

                  <e-autocomplete
                    v-else
                    :items="etapas"
                    :return-object="false"
                    :error-messages="errors"
                    :item-text="
                      (item) =>
                        `${item.descricao} - Início: ${dateFormatConvert(
                          item.periodo_inicial
                        )} Fim: ${dateFormatConvert(item.periodo_final)} ${
                          item.periodo_extensao &&
                          etapaSelecionada?.periodo_extensao >= dataAtualFormatada
                            ? ' - Estendido até: ' + dateFormatConvert(item.periodo_extensao)
                            : ''
                        }`
                    "
                    :item-value="(item) => item"
                    v-model="etapaSelecionada"
                    @change="() => verificarEtapaSelecionada()"
                    label="Selecione uma Etapa"
                    dense
                    solo
                  />
                </div>

                <v-tooltip v-if="!editing" bottom max-width="400">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="primary" class="ml-2" v-bind="attrs" v-on="on" small>
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  <div class="tooltip-content">
                    <div class="font-weight-bold mb-2">Para que serve a etapa?</div>
                    <div class="mb-2">Você seleciona a etapa para:</div>
                    <ul class="tooltip-list mb-2">
                      <li>• Dizer em qual período a aula entra (ex.: MARÇO, ABRIL)</li>
                      <li>• Liberar o cadastro (só pode lançar aulas dentro das datas da etapa)</li>
                      <li>• Organizar faltas (As faltas pertencem a uma etapa)</li>
                    </ul>
                    <div class="font-weight-bold">Exemplo:</div>
                    <div>
                      Aula dada em 10/06 → Seleciona "JUNHO". Se escolher outra etapa, o sistema
                      bloqueia.
                    </div>
                  </div>
                </v-tooltip>
              </div>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" md="4" class="d-flex align-center">
            <v-btn
              v-if="etapaBloqueada == true && etapaPendente == false"
              style="box-shadow: none"
              color="success"
              class="text-none"
              @click="() => criarPedido(editing ? etapaSelecionada : etapaSelecionada?.id)"
              >Solicitar Autorização</v-btn
            >
          </v-col>
        </v-row>

        <div v-if="etapaSelecionada && etapaBloqueada == false">
          <v-row>
            <v-col cols="12" md="12">
              <ValidationProvider name="Tipo de Aula" rules="required" v-slot="{ errors }">
                <e-label>Tipo de Aula</e-label>
                <e-autocomplete
                  :items="$constants.tiposDeAulas"
                  :return-object="false"
                  :error-messages="errors"
                  v-model="aulaSelecionada.tipo_de_aula"
                  @change="() => verificaTipoDaAula()"
                  label="Selecione um tipo de aula"
                  dense
                  solo
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row
            v-if="aulaSelecionada.tipo_de_aula && aulaSelecionada.tipo_de_aula !== 'Reposição'"
          >
            <v-col cols="12" md="6">
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="data"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <e-label>Selecione uma data</e-label>
                  <v-text-field
                    v-model="aulaSelecionada.data"
                    persistent-hint
                    :disabled="!aulaSelecionada.tipo_de_aula"
                    label="Escolha uma data"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    solo
                  ></v-text-field>
                </template>

                <v-card>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-date-picker
                          v-model="data"
                          full-width
                          class="mt-4"
                          scrollable
                          :min="inicioPeriodoEtapa"
                          :max="fimPeriodoEtapa"
                          :allowed-dates="allowedDates"
                          :events="eventos.map((evento) => evento.data)"
                          :event-color="getEventColor"
                          @update:picker-date="atualizarMesVisivel"
                        >
                          <template v-slot:day="{ date, day }">
                            <v-badge
                              :color="isFeriado(date) ? 'red' : ''"
                              :content="isFeriado(date) ? 'F' : ''"
                              overlap
                            >
                              <span>{{ day }}</span>
                            </v-badge>
                          </template>
                        </v-date-picker>
                      </v-col>
                      <v-col cols="12">
                        <v-card class="pa-2" outlined style="max-height: 150px; overflow-y: auto">
                          <v-list dense>
                            <v-list-item
                              v-for="(evento, index) in eventosFiltradosPorMes"
                              :key="index"
                            >
                              <v-list-item-icon>
                                <v-icon :color="evento.cor">mdi-calendar</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="text-caption">
                                  <strong>{{ formatarDia(evento.data) }}:</strong>
                                  {{ evento.descricao }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="$refs.dialog.save(data)">OK</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>

          <v-row v-if="mostrarCampos && aulaSelecionada.tipo_de_aula === 'Reposição'">
            <v-col cols="12" md="6">
              <v-dialog
                ref="dialog_reposicao"
                v-model="modal_reposicao"
                :return-value.sync="data_reposicao"
                persistent
                width="450px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <e-label>Selecione uma data (Sábado)</e-label>
                  <v-text-field
                    v-model="aulaSelecionada.data_reposicao"
                    persistent-hint
                    label="Escolha uma data"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    solo
                  ></v-text-field>
                </template>

                <v-card>
                  <v-container class="pa-3">
                    <v-date-picker
                      v-model="data_reposicao"
                      full-width
                      scrollable
                      :min="inicioPeriodoEtapa"
                      :max="fimPeriodoEtapa"
                      :allowed-dates="allowedDatesReposicao"
                      color="primary"
                    ></v-date-picker>
                  </v-container>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-btn text color="primary" @click="modal_reposicao = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="$refs.dialog_reposicao.save(data_reposicao)"
                      >OK</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>

          <v-row v-if="mostrarCampos">
            <v-col cols="12" md="6" v-if="aulaSelecionada.tipo_de_aula !== 'Aula Remota'">
              <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                <e-label>Selecione um horário</e-label>
                <e-autocomplete
                  :disabled="
                    aulaSelecionada.tipo_de_aula === 'Reposição'
                      ? !aulaSelecionada.data_reposicao
                      : !aulaSelecionada.data
                  "
                  :items="horarios"
                  label="Selecione um horário"
                  :item-text="(item) => item.descricao"
                  v-model="horarioSelecionado"
                  @change="() => handleHorarioChange()"
                  return-object
                  :error-messages="errors"
                  dense
                  solo
                />
                <v-progress-linear
                  v-if="searchingConflicts || searchPending"
                  :indeterminate="searchingConflicts"
                  :query="searchPending && !searchingConflicts"
                  color="primary"
                  class="mt-2"
                  height="2"
                ></v-progress-linear>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row v-if="mostrarCampos">
            <v-col cols="12">
              <ValidationProvider name="Conteúdo" rules="required" v-slot="{ errors }">
                <e-label>Conteúdo</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="aulaSelecionada.conteudo"
                  :error-messages="errors"
                  placeholder="Descreva o conteúdo da aula..."
                  rows="3"
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row v-if="mostrarCampos">
            <v-col cols="12" md="6">
              <ValidationProvider name="Habilidades" rules="required" v-slot="{ errors }">
                <e-label>Habilidades</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="aulaSelecionada.objetivos_ou_habilidades"
                  :error-messages="errors"
                  placeholder="Descreva as habilidades trabalhadas..."
                  rows="4"
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12" md="6">
              <ValidationProvider name="Metodologia" rules="required" v-slot="{ errors }">
                <e-label>Metodologia</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="aulaSelecionada.metodologia"
                  :error-messages="errors"
                  placeholder="Descreva a metodologia utilizada..."
                  rows="4"
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row v-if="mostrarCampos">
            <v-col cols="12" class="d-flex flex-wrap gap-3">
              <v-btn
                color="primary"
                :disabled="submittingForm"
                :loading="submittingForm"
                type="submit"
                class="mr-3"
                >Enviar Dados</v-btn
              >
              <v-btn
                v-if="editing"
                color="success"
                outlined
                @click="dialog.duplicar = true"
                class="mr-3"
                >Duplicar Aula</v-btn
              >
              <v-btn v-if="editing" color="info" outlined @click="dialog.exportar = true"
                >Exportar Aula</v-btn
              >
            </v-col>
          </v-row>
        </div>

        <v-row v-if="etapas?.length === 0">
          <v-col cols="12">
            <v-alert type="warning" border="left">Não existem etapas disponíveis.</v-alert>
          </v-col>
        </v-row>

        <v-row v-if="solicitacaoPendente">
          <v-col cols="12">
            <v-alert type="info" border="left"
              ><strong>Aguarde!</strong> Pedido de autorização pendente em análise.</v-alert
            >
          </v-col>
        </v-row>

        <v-row v-else-if="pedidoRecusado && etapaSelecionada">
          <v-col cols="12">
            <v-alert type="error" border="left"
              ><strong>Atenção!</strong> Seu pedido foi recusado.</v-alert
            >
          </v-col>
        </v-row>
        <v-row v-else-if="pedidoRecusado && etapaPendente == false">
          <v-col cols="12">
            <v-alert type="warning" border="left"
              ><strong>Atenção!</strong> Esta etapa está bloqueada. Solicite autorização.</v-alert
            >
          </v-col>
        </v-row>
      </form>

      <v-bottom-sheet v-model="aulasEmConflitos" scrollable>
        <v-sheet class="text-center pa-md-8 mx-lg-auto" height="auto">
          <v-btn color="error" dark small @click="aulasEmConflitos = false">Fechar</v-btn>
          <h2 class="mt-4">Aulas conflitadas</h2>
          <v-simple-table class="mt-4">
            <thead>
              <tr>
                <th class="text-left">Professor</th>
                <th class="text-left">Data/Horário</th>
                <th class="text-left">Turma</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in aulasConflitadas" :key="item.id">
                <td>{{ item.professor.nome }}</td>
                <td>
                  {{ item.data.split("-").reverse().join("/") }} - {{ item.horario.descricao }}
                </td>
                <td>{{ item.turma.descricao }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-sheet>
      </v-bottom-sheet>
    </ValidationObserver>

    <v-alert text border="left" color="orange" icon="warning" class="text-caption" v-else
      >Atenção, essa turma ainda não foi vinculada a um circuito.</v-alert
    >

    <e-modal-duplicar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :horarios="horarios"
      :form="{ ...aulaSelecionada }"
      @dialogChange="dialog.duplicar = $event"
    />
    <e-modal-exportar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.exportar"
      :form="{ ...aulaSelecionada }"
      @dialogChange="dialog.exportar = $event"
    />
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";
import { dateFormatParam } from "../../plugins/filters";

export default {
  components: { ELabel },
  props: {
    editing: { type: Boolean, default: false },
    aula_id: { type: Number, require: true },
  },
  computed: {
    tipo_de_aula() {
      return this.aulaSelecionada.tipo_de_aula;
    },
    eventosFiltradosPorMes() {
      if (!this.mesVisivel) return [];
      return this.eventos.filter((evento) => evento.data.startsWith(this.mesVisivel));
    },
    todosOsCamposObrigatoriosPreenchidos() {
      if (!this.etapaSelecionada) return false;
      if (!this.aulaSelecionada.tipo_de_aula) return false;
      if (this.aulaSelecionada.tipo_de_aula === "Reposição") {
        if (!this.aulaSelecionada.data_reposicao) return false;
      } else if (!this.aulaSelecionada.data) return false;
      if (this.aulaSelecionada.tipo_de_aula !== "Aula Remota" && !this.horarioSelecionado)
        return false;
      if (
        !this.aulaSelecionada.conteudo ||
        !this.aulaSelecionada.objetivos_ou_habilidades ||
        !this.aulaSelecionada.metodologia
      )
        return false;
      return true;
    },
  },
  data() {
    return {
      submittingForm: false,
      dataAtualFormatada: null,
      diasPermitidosParaCriarAula: [0, 1, 2, 3, 4, 5, 6],
      avisoAnime: "",
      etapaPendente: false,
      etapaBloqueada: false,
      solicitacaoPendente: false,
      idsEtapasDisponivels: [],
      idsEtapasPendentes: [],
      inicioPeriodoEtapa: null,
      fimPeriodoEtapa: null,
      etapaSelecionada: null,
      etapas: null,
      data: null,
      data_reposicao: null,
      modal: false,
      modal_reposicao: false,
      mostrarCampos: false,
      aulasEmConflitos: false,
      aulasConflitadas: [],
      aulaSelecionada: {
        data: null,
        data_reposicao: null,
        tipo_de_aula: null,
      },
      searchingConflicts: false,
      searchPending: false,
      horarioSelecionado: null,
      horarios: [],
      gestaoDeAula: null,
      eventos: [],
      mesVisivel: null,
      pedidoAprovado: null,
      pedidoRecusado: null,
      dialog: {
        duplicar: false,
        exportar: false,
      },
    };
  },
  watch: {
    tipo_de_aula(newValue, oldValue) {
      this.aulasEmConflitos = false;
      this.mostrarCampos = true;
      if (newValue === "Reposição") {
        this.aulaSelecionada.data = null;
        this.data = null;
        this.carregarTodosHorariosdoTurno();
      } else if (oldValue === "Reposição") {
        this.aulaSelecionada.data_reposicao = null;
        this.data_reposicao = null;
      }
    },
    data(value) {
      if (!value) return;
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );
      this.aulaSelecionada.data = data_old;
      this.filtrarHorariosPorDiaDaSemana(new Date(`${value}T00:00:00`).getDay());
      this.horarioSelecionado = null;
      this.pesquisaAulas();
    },
    data_reposicao(value) {
      if (!value) return;
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );
      this.aulaSelecionada.data_reposicao = data_old;
      this.horarioSelecionado = null;
      this.carregarTodosHorariosdoTurno();
    },
  },
  methods: {
    validarData(d) {
      return dateFormatParam(d, "d/m/y");
    },
    dateFormatConvert(d, f) {
      return dateFormatParam(d, f);
    },

    async carregarFeriados() {
      try {
        const response = await this.$services.calendarioLetivoService.syncAll();
        this.eventos = response.map((evento) => ({
          data: evento.start,
          descricao: evento.descricao,
          cor: evento.color,
          is_feriado: evento.evento?.is_feriado,
        }));
      } catch (error) {
        console.error(error);
      }
    },

    verificarEventoBloqueiaAula(dataStr) {
      const dataISO = dataStr.split("/").reverse().join("-");
      return this.eventos.find((e) => e.data === dataISO && e.is_feriado);
    },

    async loadData() {
      try {
        this.$loaderService.open("Carregando...");
        const gestaoId = this.$route.params.gestaoDeAulaId;
        const response = await this.$services.gestoesDeAulasService.listarAulasGestao(gestaoId);
        this.gestaoDeAula = response.gestaoDeAula;
        this.horarios = response.horarios;

        const aula = await this.getAula();
        this.aulaSelecionada = { ...this.aulaSelecionada, ...aula };

        if (aula.horario_id) {
          this.horarioSelecionado = this.horarios.find((horario) => horario.id === aula.horario_id);
        }
        if (this.gestaoDeAula.turma.circuito_nota_id) {
          const etpResp = await this.$services.etapasService.syncAllEtapasDisponiveis(
            this.gestaoDeAula.turma.circuito_nota_id,
            gestaoId,
            "aula"
          );
          this.etapas = etpResp.etapas;
          this.idsEtapasDisponivels = etpResp.disponiveis;
          this.etapas.forEach((e) => this.verificarSeTemPedido(e.id));
          if (this.editing) this.getEtapa();
        }

        if (this.aulaSelecionada.data) {
          this.data = this.aulaSelecionada.data; // ISO
          this.aulaSelecionada.data = this.data.split("-").reverse().join("/");
        }
        if (this.aulaSelecionada.data_reposicao) {
          this.data_reposicao = this.aulaSelecionada.data_reposicao;
          this.aulaSelecionada.data_reposicao = this.data_reposicao.split("-").reverse().join("/");
        }

        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    getEtapa() {
      const etapa = this.etapas.find((d) => d.id === this.aulaSelecionada.etapa_id);
      if (etapa) {
        this.etapaSelecionada = etapa.id;
        this.verificarEtapaSelecionada();
      }
    },

    verificarEtapaSelecionada() {
      const etapaObj = this.editing
        ? this.etapas.find((e) => e.id === this.etapaSelecionada)
        : this.etapaSelecionada;

      if (!etapaObj) return;

      this.inicioPeriodoEtapa = dateFormatParam(etapaObj.periodo_inicial, "y-m-d");
      this.fimPeriodoEtapa =
        etapaObj.periodo_extensao || dateFormatParam(etapaObj.periodo_final, "y-m-d");

      this.etapaBloqueada = !this.idsEtapasDisponivels.includes(etapaObj.id);
      this.solicitacaoPendente = this.idsEtapasPendentes.includes(etapaObj.id);
      this.verificarSeTemPedido(etapaObj.id);
    },

    aplicarDadosPedido(id, data) {
      if (data.aprovados?.length) {
        this.pedidoAprovado = data.aprovados[0];
        this.etapaBloqueada = false;
        this.fimPeriodoEtapa = this.pedidoAprovado.data_expiracao;

        if (!this.idsEtapasDisponivels.includes(id)) {
          this.idsEtapasDisponivels.push(id);
        }
      }

      if (data.pendentes?.length) {
        if (!this.idsEtapasPendentes.includes(id)) {
          this.idsEtapasPendentes.push(id);
        }

        this.solicitacaoPendente =
          id === (this.editing ? this.etapaSelecionada : this.etapaSelecionada?.id);
      }

      if (data.recusados?.length) {
        this.pedidoRecusado = data.recusados[data.recusados.length - 1];
      }
    },

    async verificarSeTemPedido(id) {
      if (this.pedidosCache[id]) {
        const data = this.pedidosCache[id];
        this.aplicarDadosPedido(id, data);
        return;
      }

      const resp = await this.$services.autorizacoesService.verificarPedidosDeferidos(id, 1);
      const data = resp?.data || {};

      this.pedidosCache[id] = data;
      this.aplicarDadosPedido(id, data);
    },

    allowedDates(val) {
      const dataISO = new Date(val).toISOString().split("T")[0];
      const ehFeriado = this.eventos.some((e) => e.data === dataISO && e.is_feriado);
      return !ehFeriado;
    },

    allowedDatesReposicao(val) {
      return new Date(`${val}T00:00:00`).getDay() === 6; // Apenas Sábados
    },

    async handleHorarioChange() {
      this.tipo_de_aula === "Reposição" ? this.pesquisaAulasReposicao() : this.pesquisaAulas();
    },

    async pesquisaAulas() {
      if (!this.data || !this.horarioSelecionado || this.tipo_de_aula === "Reposição") return;
      this.executarPesquisaConflito(this.data);
    },

    async pesquisaAulasReposicao() {
      if (!this.data_reposicao || !this.horarioSelecionado) return;
      this.executarPesquisaConflito(this.data_reposicao);
    },

    async executarPesquisaConflito(data_aula) {
      const resp = await this.$services.aulasService.pesquisarAulasEmConflitos(
        data_aula,
        this.horarioSelecionado.id,
        this.gestaoDeAula.turma.id,
        this.aula_id
      );
      if (resp.data.length > 0) {
        this.aulasEmConflitos = true;
        this.aulasConflitadas = resp.data;
        this.mostrarCampos = false;
        this.horarioSelecionado = null;
      } else {
        this.mostrarCampos = true;
      }
    },

    carregarTodosHorariosdoTurno() {
      const turnoId = this.gestaoDeAula.turma.turno?.id;
      this.horarios = this.gestaoDeAula.relacoesDiasHorarios
        .map((r) => r.horario)
        .filter((h) => h.turno_id === turnoId)
        .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
    },

    filtrarHorariosPorDiaDaSemana(dia) {
      this.horarios = this.gestaoDeAula.relacoesDiasHorarios
        .filter((r) => r.dia.id === dia)
        .map((r) => r.horario);
    },

    async getAula() {
      const { aula_id, gestaoDeAulaId } = this.$route.params;

      const resp = await this.$services.gestoesDeAulasService.listarAulasGestao(gestaoDeAulaId);
      this.gestaoDeAula = resp.gestaoDeAula;
      this.horarios = resp.horarios;

      if (this.editing) {
        const aulaResp = await this.$services.aulasService.getAula(parseInt(aula_id, 10));
        return aulaResp;
      }

      return {
        data: null,
        data_reposicao: null,
        tipo_de_aula: null,
      };
    },

    async submitForm() {
      this.submittingForm = true;
      const payload = { ...this.aulaSelecionada };

      // Formata datas para o Banco (YYYY-MM-DD)
      if (this.tipo_de_aula === "Reposição") {
        payload.data = this.data_reposicao;
        payload.data_reposicao = this.data_reposicao;
      } else {
        payload.data = this.data;
      }

      payload.horario_id = this.horarioSelecionado?.id;
      payload.horario_inicial = this.horarioSelecionado?.inicio;
      payload.horario_final = this.horarioSelecionado?.final;
      payload.etapa_id = this.editing ? this.etapaSelecionada : this.etapaSelecionada.id;
      payload.gestao_de_aula = parseInt(this.$route.params.gestaoDeAulaId, 10);

      try {
        if (this.editing) {
          await this.$services.aulasService.atualizar(payload);
          this.$toast.success("Aula editada!");
        } else {
          payload.disciplina_id = this.gestaoDeAula.disciplina_id;
          payload.turma_id = this.gestaoDeAula.turma_id;
          payload.instrutor_id = this.gestaoDeAula.instrutor_id;
          await this.$services.aulasService.criar(payload);
          this.$toast.success("Aula criada!");
        }
        this.$router.push({ name: "aulas" });
      } catch (e) {
        this.$handleError(e);
      }
      this.submittingForm = false;
    },

    atualizarMesVisivel(date) {
      this.mesVisivel = date.substring(0, 7);
    },
    formatarDia(d) {
      return d.split("-")[2];
    },
    isFeriado(d) {
      return this.eventos.some((e) => e.data === d && e.is_feriado);
    },
    getEventColor(d) {
      return this.isFeriado(d) ? "red" : "primary";
    },
    criarPedido(id) {
      this.$router.push({ name: "autorizacoes.create", params: { etapa: id, tipo: "aula" } });
    },
    verPedidos() {
      this.$router.push({ name: "autorizacoes" });
    },
  },
  mounted() {
    this.carregarFeriados();
    this.loadData();
    const hoje = new Date();
    this.dataAtualFormatada = hoje.toISOString().split("T")[0];
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 8px;
}

.v-btn {
  text-transform: none;
}

.gap-3 > * {
  margin-right: 12px;
}

.gap-3 > *:last-child {
  margin-right: 0;
}

.tooltip-content {
  font-size: 13px;
  text-align: left;
}

.tooltip-list {
  padding-left: 8px;
  list-style: none;
}
</style>
